import React, { useCallback, useEffect, useState } from "react";
import styled from 'styled-components';
import theme from "../../styles/theme";
import { ExpandLess } from "@mui/icons-material";
import { Autocomplete, Button, Collapse, TextField } from "@mui/material";
import { useGetProjectSurveyList, useGetSurveyCodeList, useSetProjectSurvey } from '../../interfaces/survey';
import { MODAL_QUERY_NM } from "../../interfaces/modal";
import { useQueryClient } from "react-query";

const MainWrap = styled.div`
    width: 100%;
    min-height: 100%;
    max-height: 100%;
    display: flex;
    flex-direction: column;
`;

const TitleLine = styled.ul`
    list-style-type: none;
    padding:0;
    // padding: 0 0.4rem;
    margin:0;
    border-bottom: 2px solid ${theme.color.black[40]};
    li {
        display: grid;
        grid-template-columns: 0.2rem 14rem 0.2rem;
        gap: 0.8rem;
        font-size: 1rem;
        font-weight: bold;
        line-height: 2rem;
        height: 2rem;
    }
`;

const DescArea = styled.ul`
    flex-grow: 1;
    list-style-type: none;
    width: 100%;
    height: 100%;
    min-height: 100%;
    max-height: 100%;
    padding: 0;
    margin: 0;
    overflow-x: hidden;
    overflow-y: auto;
    cursor: pointer;
    .descLiItem  {
        width: 100%;
        gap: 0.8rem;
        font-size: 1rem;
        line-height: 2rem;
        height: 2rem;
        border-bottom: 1px solid ${theme.color.black[20]};
        display: grid;
        grid-template-columns: 0.2rem 14rem 0.2rem;
        gap: 1rem;
        span:nth-child(1) {
            text-align: right;
        }
    }
    .descLiItem:last-child{
        border: 0;
    }
    .selected {
        background: ${theme.color.primary.pupple2};
    }
`;

const SurveyList = ({pid, onClick}) => {

    const [list, setList] = useState();
    const [selectedSid, setSelectedSid] = useState();
    
    const [surTpList, setSurTpList] = useState([]);
    const [ccnmList, setCcnmList] = useState([]);

    const {data, refetch} = useGetProjectSurveyList(pid);
    const {data: codeList} = useGetSurveyCodeList();

    useEffect(()=>{
        refetch();
    },[pid])

    useEffect(()=>{
        data && setList(data);
    },[data])

    useEffect(()=>{
        if(codeList){
            setSurTpList(codeList.sur_tp.map((item,index)=>({
                ...item,
                label:item.value})
                ));
            setCcnmList(codeList.cars_class.map((item,index)=>({
            ...item,
            label:item.ccnm})
            ));
        }
    },[codeList])

    const handleRowClick = (item) => {
        setSelectedSid(item && item.sid);
        onClick && onClick(item)
    }

    return (
        <MainWrap>
            <TitleLine>
                <li>
                    <span>&nbsp;</span>
                    <span>조사명</span>
                    <span />
                </li>
            </TitleLine>
            <DescArea>
                {list && list.length > 0 &&
                    list.map((item,index)=>(
                        <li className={'descLiItem '+(selectedSid === item.sid ? 'selected':'')} onClick={()=>handleRowClick(item)}>
                            <span>&nbsp;</span>
                            <span>{item.snm}</span>
                            <span />
                        </li>
                    ))
                }
            </DescArea>
            <Button variant='contained' style={{width:'100%'}} onClick={()=>handleRowClick({})}>조사추가</Button>
        </MainWrap>
    )
}

export default SurveyList;